//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FeedbackBlockItem',

  emits: [
    'open'
  ],

  props: {
    item: {
      type: Object,
      default: () => {}
    },
  },

  data () {
    return {
      isShowPlayButton: Boolean(this.item.video),
    }
  },

  computed: {
    imagesArray: function () {
      return this.item.images || []
    }
    // isShowPlayButton: function () {
    //   if (!this.$refs[`refVideo-${this.item.video}`]) {
    //     return true
    //   }
    //   return this.$refs[`refVideo-${this.item.video}`]?.paused || true;
    // }
  },
  methods: {
    handleVideo: function () {
      // если надо будет делать луп и перейдем на динамический id, то переопределимся на рандомный id элементов

      // console.log('____________________________тест')
      // console.log('this.$refs', this.$refs)
      // if (!this.videoPlay) {
      //   this.videoPlay = true;
      //   this.$refs[`refVideo-${this.item.video}`].play()
      //   return;
      // }
      // this.videoPlay = false;
      // this.$refs[`refVideo-${this.item.video}`].pause()

      return false
      if (this.$refs[`refVideo-${this.item.video}`].paused) {
        this.$refs[`refVideo-${this.item.video}`].play();
        this.isShowPlayButton = false;
      } else {
        this.$refs[`refVideo-${this.item.video}`].pause();
        this.isShowPlayButton = true;
      }
    },
    openBigCard: function () {
      if (!this.isShowPlayButton && this.item.video) {
        return null
      }
      this.$emit('open', this.item);
    }
  }
}
